<template>
  <div>
    <div>
      <div class="row" style="margin-bottom: 10px;">
        <div class="col-md-9 col-12">
        </div>
        <div class="col-md-3 col-12 d-flex justify-content-end">
          <el-button v-if="fileStatus == 0" size="small" type="danger" class="status-button" disabled>
            {{ $t('Fayllar_yüklənməyib') }}
          </el-button>
      
          <el-button v-if="fileStatus == 1" size="small" type="warning" class="status-button" disabled>
            {{ $t('Fayllar_qismən_yüklənib') }}
          </el-button>
      
          <el-button v-if="fileStatus == 2" size="small" type="success" class="status-button" disabled>
            {{ $t('Fayllar_tam_yüklənib') }}
          </el-button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-table ref="claimDocs" :default-expand-all="true" v-loading="loading" :data="claimdocs.filter(
          (claimdocs) =>
            !search ||
            claimdocs.claimDocTmplName
              .toLowerCase()
              .includes(search.toLowerCase())
        )
          " style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div style="margin-left: 40px">

                <!-- <div class="row">
                  <div class="col-12">
                    <span>{{$t('Sənədə_uyğun_fayllar')}}</span>
                  </div>
                  <dir class="col-12">
                    <upload :disabled="readonly" ref="upload" :sourcetype="3" :sourceId="scope.row.id"
                      :autoupload="true" :downloadAll="false" @filesloaded="getClaimDocs">
                    </upload>
                  </dir>
                </div> -->
                <div class="row">
                  <div class="col-md-12 col-12">
                    <div style="display: flex; align-items: center;margin-left: 40px;">
                      <upload style="flex: 1;" :disabled="readonly" ref="upload" :sourcetype="3"
                        :sourceId="scope.row.id" :autoupload="true" @filesloaded="getClaimDocs" :acceptonlyimages="true"
                        :downloadAll="true">
                      </upload>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Növ')" prop="personTypeName">
            <template slot-scope="scope">
              <span style="color:#909399;font-weight: bold;">{{ scope.row.claimDocTmplName }}</span>
            </template>
          </el-table-column>

          <el-table-column :label="$t('Status')" width="100">
            <template slot-scope="scope">
              <i class="fa fa-circle" style="font-size: var(--font-primary);" :class="scope.row.status === 1 ? 'text-success' : 'text-danger'
                "></i>
            </template>
          </el-table-column>
          <el-table-column :label="$t('S.A.A_/_Sənədin_yüklənmə_tarixi')" prop="fileCreatedBy" width="350">
          </el-table-column>

        </el-table>
      </div>
    </div>

    <claim-docs ref="claimdoc" @saved="saved" />
  </div>
</template>

<script>
  import ClaimDocs from "../servicecenter/ClaimDocs.vue";
  import Upload from "../components/Upload.vue";
  import {
    GetClaimDocs,
    DeleteClaimDoc
  } from "../../services/claim";
  import {
    FileUploadStatus,
  } from "../../services/common";
  export default {
    components: {
      Upload,
      ClaimDocs,
    },
    props: {
      id: { type: Number, default: 0 },
      readonly: { type: Boolean, default: false },
    },
    data() {
      return {
        claimId: this.id,
        loading: false,
        claimdocs: [],
        fileStatus: 0,
        search: "",
        uid: this.$store.state.user.id,
      };
    },
    methods: {

      newClaimDoc() {
        this.$refs["claimdoc"].new(this.id);
      },
      saved() {
        this.getClaimDocs();
      },
      getClaimDocs() {
        GetClaimDocs(this.id).then((response) => {
          if (response.data) {
            this.claimdocs = response.data.data;
            this.fileUploadStatus();
          } else {
            this.$message({
              type: "warning",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });
      },
      fileUploadStatus() {
        FileUploadStatus(this.id).then((response) => {
          if (response) {
            this.fileStatus = response.data;
          } else {
            this.$message({
              type: "warning",
              message: this.$t('Səhv_əməliyyat'),
            });
          }
        });
      },
      handleCommand(command) {
        let id = command.row.id;
        if (command.action === "delete") this.handleDelete(id);
      },
      handleDelete(id) {
        this.$confirm(this.$t('Sənəd_növü_ləğv_olunsun'), this.$t('Təsdiqləyin'), {
          cancelButtonText: this.$t('Xeyr'),
          confirmButtonText: this.$t('Bəli'),
          type: "error",
        })
          .then(() => {
            this.loading = true;
            DeleteClaimDoc(id, this.uid).then((response) => {
              this.loading = false;
              if (response.data) {
                if (response.data.status !== 1) {
                  this.$message({
                    type: "error",
                    message: response.data.message,
                  });
                } else {
                  this.$message({
                    type: "success",
                    message: this.$t('Ləğv_olundu'),
                  });
                  this.getClaimDocs();
                }
              } else {
                this.$message({
                  type: "error",
                  message: this.$t('Səhv_əməliyyat'),
                });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Xitam verildi",
            });
          });
      },
    }, watch: {
      id() {
        this.claimId = this.id;
      },
    },
    mounted: function () {
      this.getClaimDocs();
    },

  };
</script>

<style lang="scss" scoped>
.status-button {
  margin-bottom: 4px;
  cursor: default;
  color: white;
  
  &.is-disabled {
    opacity: 1 !important;
    color: white;
  }

  &.el-button--danger {
    &.is-disabled {
      background-color: #f56c6c !important;
      border-color: #f56c6c !important;
    }
  }
  
  &.el-button--warning {
    &.is-disabled {
      background-color: #e6a23c !important;
      border-color: #e6a23c !important;
    }
  }
  
  &.el-button--success {
    &.is-disabled {
      background-color: #67c23a !important;
      border-color: #67c23a !important;
    }
  }
}
</style>